
const columnChart = {
    series: [{
        name: 'عدد الذكور',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'العدد الكلي',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'عدد الاناث',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: true,
            }
        },
        legend: {
            show: true,
            position: 'top',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '85%',
                endingShape: 'rounded',
                borderRadius: 4
            },
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: '10px'
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        colors: ['#34c38f', '#556ee6', '#f46a6a'],
        xaxis: {
            categories: ['أربيل', 'السليمانية', 'صلاح الدين', 'نينوى', 'ذي قار', 'دهوك', 'الأنبار', 'كركوك', 'البصرة','الديوانية', 'ميسان', 'المثنى', 'ديالى', 'بابل', 'النجف', 'كربلاء', 'واسط', 'بغداد'],
        },
        yaxis: {
            title: {
                style: {
                    fontWeight: '500',
                },
            },
        },
        grid: {
            borderColor: '#f1f1f1',
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return  val 
                }
            }
        }
    }
};

const barChart = {
    series: [{
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: true,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '45%',
                endingShape: 'rounded',
                borderRadius: 4
            }
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: '10px'
            }
        },
        // colors: ['#6660e0'],
        grid: {
            borderColor: '#000000',
        },
        xaxis: {
            categories: ['بدون تحصيل', 'ابتدائية', 'متوسطة', 'اعدادية', 'دبلوم', 'بكالوريوس', 'دبلوم عالي', 'ماجستير', 'دكتوراه'],
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val 
                },
                title: {
                    formatter: () => 'العدد الكلي : '
                }
            }
        }
        // yaxis: {
        //     reversed: true,
        //     axisTicks: {
        //     show: false
        //     }
        // }
    }
};


const pieChart = {
    series: [0, 0, 0, 0, 0, 0],
    chartOptions: {
        labels: ["الاطفال : 4-9", "المراهقون : 10-17", "الشباب : 18-29", "البالغون : 30-44", "منتصف العمر : 45-59", "كبار السن : 60-اكثر"],
        colors: ["#7EC8E3", "#76C893", "#FFD56B", "#FFA45B", "#E26D5C", "#B497D6"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        chart: {
            toolbar: {
                show: true,
            }
        },
        dataLabels: {
            enabled: true,
            // formatter: function (val, opts) {
            //     return val.toFixed(1) + '%';
            // },
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]; // 👈 القيمة فقط
            },
            // formatter: function (val, opts) {
            //     return opts.w.globals.labels[opts.seriesIndex] + ": " + val.toFixed(1) + "%";
            // }
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 340
                },
                legend: {
                    show: true
                },
            }
        }]
    }
};


export { columnChart, barChart, pieChart };